
    <div >

                <img (click)="openAiChatWindow()" class="ai-chat-hint tooltip-index" *ngIf="!unreadGif;" src="assets/img/sparkIcon.png" triggers="mouseenter:mouseleave" placement="right" ngbTooltip=" {{'ct.openai.global.aitooltip.txet' | translate}}">
                <img (click)="openAiChatWindow()" *ngIf="unreadGif" src="assets/img/flora_new_msg.gif" ngbTooltip=" {{'ct.openai.global.aitooltip.txet' | translate}}">

        </div>

